import { STAFF_TOKEN_WHILE_IMPERSONATE } from 'modules/Auth/AuthProvider/constants';

/**
 * The staffer's Auth0 session ended while impersonating. Requests stop rather than go without
 * the staff header, which the backend would take for the member acting alone.
 */
export class Auth0StaffSessionEndedError extends Error {
    constructor() {
        super("The staffer's Auth0 session has ended");
        this.name = 'Auth0StaffSessionEndedError';
    }
}

// Stored in place of the staffer's Django token by an impersonation started from an Auth0
// session, whose token lives only in the SDK. Its presence still marks the impersonation.
export const AUTH0_STAFF_TOKEN = { auth0: true } as const;

/** Whether this browser is impersonating a member from an Auth0 staff session. */
export function isAuth0StaffImpersonation(): boolean {
    try {
        const stored: unknown = JSON.parse(localStorage.getItem(STAFF_TOKEN_WHILE_IMPERSONATE) ?? 'null');

        return typeof stored === 'object' && stored !== null && 'auth0' in stored && stored.auth0 === true;
    } catch {
        return false;
    }
}
